import { useState, useEffect } from "react";
import { ReactLenis } from "lenis/react";
import { motion, AnimatePresence } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import HexLogo from "@/components/HexLogo";
import Nav from "@/components/Nav";
import Hero from "@/components/sections/Hero";
import Ticker from "@/components/sections/Ticker";
import Manifesto from "@/components/sections/Manifesto";
import Intention from "@/components/sections/Intention";
import Family from "@/components/sections/Family";
import Origin from "@/components/sections/Origin";
import SiteFooter from "@/components/sections/SiteFooter";
import "@/App.css";

const Preloader = () => (
  <motion.div
    data-testid="preloader"
    className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#030303]"
    initial={{ opacity: 1 }}
    exit={{ opacity: 0, transition: { duration: 0.8, ease: "easeInOut" } }}
  >
    <motion.div
      initial={{ scale: 0.6, opacity: 0, rotate: -40 }}
      animate={{ scale: 1, opacity: 1, rotate: 0 }}
      transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
    >
      <HexLogo className="w-16 h-16" />
    </motion.div>
    <div className="mt-8 overflow-hidden">
      <motion.p
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 0.9, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
        className="font-serif italic text-3xl md:text-4xl text-zinc-200"
      >
        Water has memory.
      </motion.p>
    </div>
    <motion.div
      className="mt-8 h-px bg-teal-400/60"
      initial={{ width: 0 }}
      animate={{ width: 180 }}
      transition={{ duration: 1.4, delay: 0.7, ease: "easeInOut" }}
    />
  </motion.div>
);

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 2200);
    document.documentElement.classList.add("dark");
    return () => clearTimeout(t);
  }, []);

  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="relative bg-[#030303] text-zinc-100 antialiased font-body">
        <div className="grain" />
        <AnimatePresence>{loading && <Preloader />}</AnimatePresence>

        <Nav />
        <main>
          <Hero />
          <Ticker />
          <Manifesto />
          <Intention />
          <Family />
          <Origin />
        </main>
        <SiteFooter />

        <Toaster
          theme="dark"
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#0a0a0a",
              border: "1px solid #14532d",
              color: "#f4f4f5",
            },
          }}
        />
      </div>
    </ReactLenis>
  );
}

export default App;
